import { Portal } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuPortal = Portal;
